export const environment = {
  production: false,
  urlBase: 'http://localhost:8080',
  firebaseConfig: {
    apiKey: 'AIzaSyAOnYBOoT3Or4ipc3rBbixLTYjb1BGDA2c',
    authDomain: 'analitica-nv-pruebas.firebaseapp.com',
    projectId: 'analitica-nv-pruebas',
    storageBucket: 'analitica-nv-pruebas.firebasestorage.app',
    messagingSenderId: '869579121266',
    appId: '1:869579121266:web:eb9b54a130616c3a1a18eb',
    apiUrl: 'https://identitytoolkit.googleapis.com/v1',
  },
  KEY: '',
  genIA: {
    iaURL: 'https://gen-ai-back-869579121266.us-central1.run.app',
    apiKey: '2789a411-bfdf-4149-8620-e03c096b8a49'
  }
};
